module.exports = __webpack_public_path__ + "img/m1.3ea6d871.png";